import {
  pointInsideBoundingBox,
  pointInRectangle,
  pointInEllipse
} from "./intersection.js";

const intersection = {
  pointInsideBoundingBox,
  pointInEllipse,
  pointInRectangle
};

export default intersection;
